import actionTypes from '../../constants/actions/importarDireccionesExcel/importarDireccionesExcel'

export function initialState () {
  return {
    showModalImportarDireccionesExcel: false,
    archivoExcel: [],
    listImportarDireccionesExcel: []
  }
}

export function abrirModalImportarDireccionesExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarDireccionesExcel: true
  }
}

export function cerrarModalImportarDireccionesExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarDireccionesExcel: false,
    archivoExcel: [],
    listImportarDireccionesExcel: []
  }
}

export function subirArchivosImportarDireccionesExcel (state, {archivoExcel}) {
  return {
    ...state,
    archivoExcel: archivoExcel
  }
}

export function submitImportarDireccionesExcelSuccess (state, {listImportarDireccionesExcel}) {
  return {
    ...state,
    listImportarDireccionesExcel: listImportarDireccionesExcel
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.ABRIR_MODAL_IMPORTAR_DIRECCIONES_EXCEL:
      return abrirModalImportarDireccionesExcel(state, action)
     case actionTypes.CERRAR_MODAL_IMPORTAR_DIRECCIONES_EXCEL:
      return cerrarModalImportarDireccionesExcel(state, action)
     case actionTypes.SUBIR_ARCHIVOS_IMPORTAR_DIRECCIONES_EXCEL:
      return subirArchivosImportarDireccionesExcel(state, action)
     case actionTypes.SUBMIT_IMPORTAR_DIRECCIONES_EXCEL_SUCCESS:
      return submitImportarDireccionesExcelSuccess(state, action)
    default:
      return state
  }
}
